<app-banner [isCommonBanner]="true" [isDefaultPageBanner]="false" [banner]="banner"></app-banner>
<app-left-side-menu-operational-assurances [pageTitle]="pageTitle"></app-left-side-menu-operational-assurances>
